var map = {
	"./college-AS.jpg": 182,
	"./college-BA.jpg": 4045,
	"./college-CS-mistake.jpg": 4395,
	"./college-CS.jpg": 7664,
	"./college-ES.jpg": 546,
	"./college-FI.jpg": 8977,
	"./college-GC.jpg": 1420,
	"./college-GF.jpg": 1381,
	"./college-HI-mistake.jpg": 1832,
	"./college-HI.jpg": 1207,
	"./college-HO.jpg": 1145,
	"./college-LA.jpg": 1899,
	"./college-LS.jpg": 2009,
	"./college-LW.jpg": 3397,
	"./college-NH.jpg": 380,
	"./college-NU.jpg": 781,
	"./college-PP.jpg": 4362,
	"./college-SU.jpg": 9862,
	"./college-TB.jpg": 9780,
	"./college-TE.jpg": 1743,
	"./college-UC.jpg": 82,
	"./college-default.jpg": 5675
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 3637;